import React from 'react';
import { Select, Input, Row, Col, theme as antdTheme } from 'antd';
import { usePermissions } from '../../../hooks/usePermissions';

const { TextArea } = Input;
const { useToken } = antdTheme;

const PaymentAndRemarks = ({ form, setForm, readOnly = false }) => {
  const { token } = useToken();
  const { canViewField, canEditField } = usePermissions();

  const canViewPaymentMethod = canViewField('billing', 'paymentMethod');
  const canEditPaymentMethod = canEditField('billing', 'paymentMethod');

  const containerStyle = {
    marginTop: 20,
    padding: 8,
    borderRadius: token.borderRadiusLG,
    backgroundColor: token.colorBgContainer,
  };

  return (
    <div style={containerStyle} className="payment-remarks">
      <Row gutter={[12, 12]} align="top">
        {canViewPaymentMethod && (
        <Col xs={24} sm={8} md={6} lg={5}>
          <Select
            value={form.paymentMode}
            onChange={(value) => setForm({ ...form, paymentMode: value })}
            disabled={readOnly || !canEditPaymentMethod}
            size="middle"
            style={{
              width: '100%',
              borderRadius: token.borderRadiusLG,
              backgroundColor: (readOnly || !canEditPaymentMethod) ? token.colorBgContainerDisabled : token.colorBgContainer,
            }}
            placeholder="Payment Mode"
            options={[
              { label: 'Cash', value: 'CASH' },
              { label: 'Bank Transfer', value: 'BANK_TRANSFER' },
              { label: 'UPI', value: 'UPI' },
            ]}
            popupStyle={{ borderRadius: token.borderRadiusLG }}
          />
          
        </Col>
        )}

        <Col xs={24} sm={16} md={18} lg={19}>
          <TextArea
            value={form.remarks}
            onChange={(e) => setForm({ ...form, remarks: e.target.value })}
            disabled={readOnly}
            placeholder="Remarks"
            autoSize={{ minRows: 3, maxRows: 8 }}
            style={{
              width: '100%',
              borderRadius: token.borderRadiusLG,
              boxShadow: readOnly ? 'none' : '0 1px 3px rgba(0,0,0,0.06)',
              backgroundColor: readOnly ? token.colorBgContainerDisabled : token.colorBgContainer,
              resize: 'vertical',
              padding: 10,
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PaymentAndRemarks;
